export default (function (
/* page */
_ref,
/* container*/
_temp, fitTo) {
  var _ref$scale = _ref.scale,
      scale = _ref$scale === void 0 ? 1 : _ref$scale,
      originalWidth = _ref.originalWidth,
      originalHeight = _ref.originalHeight,
      _ref$pageInfo = _ref.pageInfo;
  _ref$pageInfo = _ref$pageInfo === void 0 ? {} : _ref$pageInfo;
  var rotate = _ref$pageInfo.rotate;

  var _ref2 = _temp === void 0 ? {} : _temp,
      width = _ref2.width,
      height = _ref2.height;

  var rotated = rotate === 90 || rotate === 270;
  var pageWidth = rotated ? originalHeight : originalWidth;
  var pageHeight = rotated ? originalWidth : originalHeight;
  var scaleX = width / pageWidth;
  var scaleY = height / pageHeight;

  if (fitTo === 'page') {
    return Math.min(scaleX, scaleY);
  }

  if (fitTo === 'width') {
    return scaleX;
  }

  return scale;
});